import { useMissionFileCurrentDirectory } from '../../../ui/features/mission-files/hooks/useMissionFileCurrentDirectory';
import { useMissionFileMenuItems } from '../../../ui/features/mission-files/hooks/useMissionFileMenuItems';
import { useAuthorizeManageMission } from '../../../ui/features/mission/hooks/useAuthorizeManageMission';
import { useMissionsTranslation } from '../../../ui/hooks';
import { PageError } from '@juvare/common-web-ui/PageError';
import { FileManager } from '@juvare/document-library/ui/features/file-manager';
import { DocumentLibraryContextProvider } from '@juvare/document-library/ui/providers';
import { CircularProgress } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
export const MissionFiles = ({ missionId, missionTypeId, missionAccessSharing }) => {
    const { t } = useMissionsTranslation();
    const navigate = useNavigate();
    const { authorizeManageMission } = useAuthorizeManageMission();
    const allowMissionChange = authorizeManageMission(missionAccessSharing, missionTypeId);
    const { getRowMenuItems, getSlideoutMenuItems } = useMissionFileMenuItems();
    const { currentDirectoryId, isLoading, error } = useMissionFileCurrentDirectory(missionId);
    if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    if (currentDirectoryId) {
        return (React.createElement(DocumentLibraryContextProvider, null,
            React.createElement(FileManager, { navigate: navigate, customRowMenuItems: getRowMenuItems, customSlideoutMenuItems: getSlideoutMenuItems, showUploadFileButton: allowMissionChange, showCreateFolderButton: false, currentDirectoryId: currentDirectoryId, fileTableTitle: t('missions.file.title') })));
    }
    return React.createElement(PageError, { error: error });
};
